import React from 'react'
import { $neutralGray100 } from '../../../styles/colors/primitives'

function SubtractIcon({ color }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_4992_114)">
        <path d="M12 7.5H4V8.5H12V7.5Z" fill={color || $neutralGray100}/>
      </g>
      <defs>
        <clipPath id="clip0_4992_114">
          <rect width="16" height="16" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  )
}
export default SubtractIcon
